<template>
  <div>
    <div>
      <div ref="wrapper" class="loan_wrapper" v-if="editedItem">
        <div class="page page1">
          <div class="loan_header">
            <span class="nb">和潤合約編號：</span>
            <h1>和潤企業分期付款申請書(機車)</h1>
            <div class="date">
              申請日：
              <span class="y">{{ editedItem.applyDate.year }}</span
              >年 <span class="m">{{ editedItem.applyDate.month }}</span
              >月 <span class="d">{{ editedItem.applyDate.day }}</span
              >日
            </div>
          </div>
          <!--header-->
          <div class="area1">
            <div class="loan_title">申請人</div>
            <table class="table1">
              <tr>
                <td width="177px">
                  <span class="tdTit">
                    姓名：
                    <br />(公司名)
                  </span>
                  <div class="con1">
                    <span>{{ editedItem.customer.name }}</span>
                  </div>
                </td>
                <td width="177px">
                  <span class="tdTit">
                    身分證字號：
                    <br />(統編)
                  </span>
                  <div class="con2">{{ editedItem.customer.memberId }}</div>
                </td>
                <td width="195px">
                  <span class="tdTit">行動電話：</span>
                  <div class="con3">{{ editedItem.customer.cellphone }}</div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit">學歷：</span>
                  <div class="con4">
                    <span class="checkbox">
                      <input
                        type="checkbox"
                        disabled
                        :checked="editedItem.customer.educationLevel[1].value"
                      /> </span
                    >碩士以上&nbsp;
                    <span class="checkbox">
                      <input
                        type="checkbox"
                        disabled
                        :checked="editedItem.customer.educationLevel[2].value"
                      /> </span
                    >大學&nbsp;&nbsp;
                    <span class="checkbox">
                      <input
                        type="checkbox"
                        disabled
                        :checked="editedItem.customer.educationLevel[3].value"
                      /> </span
                    >專科
                    <br />
                    <span class="checkbox">
                      <input
                        type="checkbox"
                        disabled
                        :checked="editedItem.customer.educationLevel[4].value"
                      /> </span
                    >高中職&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span class="checkbox">
                      <input
                        type="checkbox"
                        disabled
                        :checked="editedItem.customer.educationLevel[5].value"
                      /> </span
                    >初中以下
                  </div>
                </td>
              </tr>
            </table>
            <table class="table2">
              <tr class="tr">
                <td width="177px">
                  <span class="tdTit">任職公司：</span>
                  <div class="con5">
                    <span>{{ editedItem.company.name }}</span>
                  </div>
                </td>
                <td width="177px">
                  <span class="tdTit">公司統編：</span>
                  <div class="con6">{{ editedItem.company.companyId }}</div>
                </td>
                <td width="195px">
                  <span class="tdTit">職稱：</span>
                  <div class="con7">
                    <span>{{ editedItem.company.title }}</span>
                  </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit">年資：</span>
                  <span class="con8">
                    {{ editedItem.company.workYear }}
                    <span>年</span>
                  </span>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <span class="tdTit">公司地址：</span>
                  <div class="con9">
                    <!--                <span>0</span><span>0</span><span>0</span>-->
                  </div>
                  <div class="con10">
                    <span>{{ editedItem.company.address }}</span>
                  </div>
                </td>
                <td>
                  <span class="tdTit">公司電話：</span>
                  <div class="con11">{{ editedItem.company.phone }}</div>
                  <span class="tdTit tdTit11">分機：</span>
                  <div class="con12"></div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit">月收入：NT</span>
                  <span class="con13">
                    {{ editedItem.company.salary }}
                    <span>元</span>
                  </span>
                </td>
              </tr>
            </table>
            <table class="table3">
              <tr class="tr">
                <td width="450px">
                  <span class="tdTit">戶籍地址：</span>
                  <div class="con14">
                    <!--                <span>0</span><span>0</span><span>0</span>-->
                  </div>
                  <div class="con15">
                    <span>{{ editedItem.customer.home.residenceAddress }}</span>
                  </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit">戶籍電話：</span>
                  <div class="con16">{{ editedItem.customer.phone }}</div>
                  <div class="con17" style="width: 130px">
                    <span class="checkbox">
                      <input
                        type="checkbox"
                        disabled
                        :checked="editedItem.customer.home.liveLevel[0].value"
                      /> </span
                    >自有
                    <span class="checkbox">
                      <input
                        type="checkbox"
                        disabled
                        :checked="editedItem.customer.home.liveLevel[1].value"
                      /> </span
                    >家人
                    <span class="s1"></span>
                    <br />
                    <span class="checkbox">
                      <input
                        type="checkbox"
                        disabled
                        :checked="editedItem.customer.home.liveLevel[3].value"
                      /> </span
                    >租賃，居住
                    <span class="s3">月</span>
                    <span class="s2" style="width: 15px">{{
                      editedItem.customer.home.liveMonth
                    }}</span>
                    <span class="s3">年</span>
                    <span class="s2" style="width: 15px">{{
                      editedItem.customer.home.liveYear
                    }}</span>
                  </div>
                </td>
              </tr>
              <tr class="trB">
                <td>
                  <span class="tdTit">通訊地址：</span>
                  <div class="con18">
                    <!--                <span>0</span><span>0</span><span>0</span>-->
                  </div>
                  <div class="con19">
                    <span>{{ editedItem.customer.home.homeAddress1 }}</span>
                  </div>
                  <div class="con20">
                    <span class="checkbox">
                      <input
                        type="checkbox"
                        disabled
                        :checked="editedItem.customer.home.homeType1[0].value"
                      /> </span
                    >同戶籍
                  </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit">通訊電話：</span>
                  <div class="con21">{{ editedItem.customer.homePhone }}</div>
                  <div class="con22" style="width: 130px">
                    <span class="checkbox">
                      <input
                        type="checkbox"
                        disabled
                        :checked="editedItem.customer.home.liveLevel2[0].value"
                      /> </span
                    >自有
                    <span class="checkbox">
                      <input
                        type="checkbox"
                        disabled
                        :checked="editedItem.customer.home.liveLevel2[1].value"
                      /> </span
                    >家人
                    <span class="s1"></span>
                    <br />
                    <span class="checkbox">
                      <input
                        type="checkbox"
                        disabled
                        :checked="editedItem.customer.home.liveLevel2[3].value"
                      /> </span
                    >租賃，居住
                    <span class="s3">月</span>
                    <span class="s2" style="width: 15px">{{
                      editedItem.customer.home.liveMonth2
                    }}</span>
                    <span class="s3">年</span>
                    <span class="s2" style="width: 15px">{{
                      editedItem.customer.home.liveYear2
                    }}</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="tdTit">繳款方式：</span>
                  <div class="con23">
                    <span class="checkbox">
                      <input
                        type="checkbox"
                        disabled
                        :checked="editedItem.paymentInfo.debitNote.isDebitNote"
                      /> </span
                    >繳款單(寄送地址：
                    <span class="checkbox">
                      <input
                        type="checkbox"
                        disabled
                        :checked="
                          editedItem.paymentInfo.debitNote.isRegistration
                        "
                      /> </span
                    >戶籍地&nbsp;&nbsp;
                    <span class="checkbox">
                      <input
                        type="checkbox"
                        disabled
                        :checked="
                          editedItem.paymentInfo.debitNote.isMailingAddress
                        "
                      /> </span
                    >通訊地&nbsp;&nbsp;&nbsp;
                    <span class="checkbox">
                      <input
                        type="checkbox"
                        disabled
                        :checked="
                          editedItem.paymentInfo.debitNote.isCompanyAddress
                        "
                      /> </span
                    >公司地)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span class="checkbox">
                      <input
                        type="checkbox"
                        disabled
                        :checked="editedItem.paymentInfo.isAutoBillPay"
                      /> </span
                    >ACH&nbsp;自動扣繳
                  </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit">E-mail：</span>
                  <div class="con24">{{ editedItem.customer.email }}</div>
                </td>
              </tr>
            </table>
            <div class="clear"></div>
          </div>
          <!--area1-->
          <div class="area2">
            <div class="loan_title">聯絡人一</div>
            <table class="table4">
              <tr class="tr">
                <td width="177px">
                  <span class="tdTit">姓名：</span>
                  <div class="con25">{{ editedItem.firstContact.name }}</div>
                </td>
                <td width="177px">
                  <span class="tdTit">關係：</span>
                  <div class="con26">{{ editedItem.firstContact.type }}</div>
                </td>
                <td width="195px">
                  <span class="tdTit">室話：</span>
                  <div class="con27">
                    {{ editedItem.firstContact.homePhone }}
                  </div>
                  <span class="tdTit tdTit27">分機：</span>
                  <div class="con28"></div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit">行動：</span>
                  <div class="con29">
                    {{ editedItem.firstContact.cellphone }}
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="4" class="tdEnd">
                  <span class="tdTit">聯絡地址：</span>
                  <div class="con30">
                    <!--                <span>0</span><span>0</span><span>0</span>-->
                  </div>
                  <div class="con31">
                    <span>{{ editedItem.firstContact.address }}</span>
                  </div>
                </td>
              </tr>
            </table>
            <div class="clear"></div>
          </div>
          <!--area2-->
          <div class="area3">
            <div class="loan_title">聯絡人二</div>
            <table class="table5">
              <tr class="tr">
                <td width="177px">
                  <span class="tdTit">姓名：</span>
                  <div class="con32">{{ editedItem.secondContact.name }}</div>
                </td>
                <td width="177px">
                  <span class="tdTit">關係：</span>
                  <div class="con33">{{ editedItem.secondContact.type }}</div>
                </td>
                <td width="195px">
                  <span class="tdTit">室話：</span>
                  <div class="con34">
                    {{ editedItem.secondContact.homePhone }}
                  </div>
                  <span class="tdTit tdTit34">分機：</span>
                  <div class="con35"></div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit">行動：</span>
                  <div class="con36">
                    {{ editedItem.secondContact.cellphone }}
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="4" class="tdEnd">
                  <span class="tdTit">聯絡地址：</span>
                  <div class="con37">
                    <!--                <span>0</span><span>0</span><span>0</span>-->
                  </div>
                  <div class="con38">
                    <span>{{ editedItem.secondContact.address }}</span>
                  </div>
                </td>
              </tr>
            </table>
            <div class="clear"></div>
          </div>
          <!--area2-->
          <div class="area4">
            <div class="loan_title">保證人</div>
            <table class="table6">
              <tr>
                <td width="177px">
                  <span class="tdTit">姓名：</span>
                  <div class="con39">{{ editedItem.jointGuarantor.name }}</div>
                </td>
                <td width="177px">
                  <span class="tdTit">身分證字號：</span>
                  <div class="con40">
                    {{ editedItem.jointGuarantor.memberId }}
                  </div>
                </td>
                <td width="195px">
                  <span class="tdTit">行動電話：</span>
                  <div class="con41">
                    {{ editedItem.jointGuarantor.cellphone }}
                  </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit">關係：</span>
                  <div class="con42">{{ editedItem.jointGuarantor.type }}</div>
                </td>
              </tr>
            </table>
            <table class="table7">
              <tr class="tr">
                <td width="177px">
                  <span class="tdTit">任職公司：</span>
                  <div class="con43">
                    <span>{{ editedItem.jointGuarantor.companyName }}</span>
                  </div>
                </td>
                <td width="177px">
                  <span class="tdTit">公司統編：</span>
                  <div class="con44"></div>
                </td>
                <td width="195px">
                  <span class="tdTit">職稱：</span>
                  <div class="con45">
                    <span>{{ editedItem.jointGuarantor.title }}</span>
                  </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit">年資：</span>
                  <span class="con46">
                    {{ editedItem.jointGuarantor.workYear }}
                    <span>年</span>
                  </span>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <span class="tdTit">公司地址：</span>
                  <div class="con47">
                    <!--                <span>0</span><span>0</span><span>0</span>-->
                  </div>
                  <div class="con48">
                    <span>{{ editedItem.jointGuarantor.companyAddress }}</span>
                  </div>
                </td>
                <td>
                  <span class="tdTit">公司電話：</span>
                  <div class="con49">
                    {{ editedItem.jointGuarantor.companyPhone }}
                  </div>
                  <span class="tdTit tdTit49">分機：</span>
                  <div class="con50">
                    {{ editedItem.jointGuarantor.companySubPhone }}
                  </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit">月收入：NT</span>
                  <span class="con51">
                    {{ editedItem.jointGuarantor.salary }}
                    <span>元</span>
                  </span>
                </td>
              </tr>
            </table>
            <table class="table8">
              <tr class="tr">
                <td width="450px">
                  <span class="tdTit">戶籍地址：</span>
                  <div class="con52">
                    <!--                <span>0</span><span>0</span><span>0</span>-->
                  </div>
                  <div class="con53">
                    <span>{{
                      editedItem.jointGuarantor.home.residenceAddress
                    }}</span>
                  </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit">戶籍電話：</span>
                  <div class="con54">{{ editedItem.jointGuarantor.phone }}</div>
                  <div class="con55" style="width: 130px">
                    <span class="checkbox">
                      <input
                        type="checkbox"
                        disabled
                        :checked="
                          editedItem.jointGuarantor.home.liveLevel[0].value
                        "
                      /> </span
                    >自有
                    <span class="checkbox">
                      <input
                        type="checkbox"
                        disabled
                        :checked="
                          editedItem.jointGuarantor.home.liveLevel[1].value
                        "
                      /> </span
                    >家人
                    <span class="s1"></span>
                    <br />
                    <span class="checkbox">
                      <input
                        type="checkbox"
                        disabled
                        :checked="
                          editedItem.jointGuarantor.home.liveLevel[3].value
                        "
                      /> </span
                    >租賃，居住
                    <span class="s3">月</span>
                    <span class="s2" style="width: 15px">{{
                      editedItem.jointGuarantor.home.liveMonth
                    }}</span>
                    <span class="s3">年</span>
                    <span class="s2" style="width: 15px">{{
                      editedItem.jointGuarantor.home.liveYear
                    }}</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="tdTit">通訊地址：</span>
                  <div class="con56">
                    <!--                <span>0</span><span>0</span><span>0</span>-->
                  </div>
                  <div class="con57">
                    <span>{{
                      editedItem.jointGuarantor.home.homeAddress1
                    }}</span>
                  </div>
                  <div class="con58">
                    <span class="checkbox">
                      <input type="checkbox" disabled /> </span
                    >同戶籍
                  </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit">通訊電話：</span>
                  <div class="con59">
                    {{ editedItem.jointGuarantor.homePhone }}
                  </div>
                  <div class="con60" style="width: 130px">
                    <span class="checkbox">
                      <input
                        type="checkbox"
                        disabled
                        :checked="
                          editedItem.jointGuarantor.home.liveLevel2[0].value
                        "
                      /> </span
                    >自有
                    <span class="checkbox">
                      <input
                        type="checkbox"
                        disabled
                        :checked="
                          editedItem.jointGuarantor.home.liveLevel2[1].value
                        "
                      /> </span
                    >家人
                    <span class="s1"></span>
                    <br />
                    <span class="checkbox">
                      <input
                        type="checkbox"
                        disabled
                        :checked="
                          editedItem.jointGuarantor.home.liveLevel2[3].value
                        "
                      /> </span
                    >租賃，居住
                    <span class="s3">月</span>
                    <span class="s2" style="width: 15px">{{
                      editedItem.jointGuarantor.home.liveMonth2
                    }}</span>
                    <span class="s3">年</span>
                    <span class="s2" style="width: 15px">{{
                      editedItem.jointGuarantor.home.liveYear2
                    }}</span>
                  </div>
                </td>
              </tr>
            </table>
            <div class="clear"></div>
          </div>
          <!--area3-->
          <table class="ps">
            <tr>
              <th>特別約定事項</th>
            </tr>
            <tr>
              <td>
                <div class="notice">
                  <b>申請人、連帶保證人確認並同意以下事項：</b>
                  <br />1.申請人(下稱甲方)及其連帶保證人於簽約時已充分知悉並同意，特約商得請求支付分期價款之權利及依本契約規定所得享受之一切權利及利益(含延遲利息及違約金)讓與
                  <b>和潤企業</b>，並同意代為管理帳務，不另為書面通知；
                  <b>和潤企業</b
                  >對於案件是否核准，保有最終同意權。案件核准後同時由
                  <b>和潤企業</b
                  >收買應收帳款之債權，甲方及其連帶保證人知悉並同意分期款項應依約繳付予
                  <b>和潤企業</b>。 <br />2.甲方及其連帶保證人均同意並授權
                  <b>和潤企業</b
                  >，於信用調查、推廣行銷及業務範圍內之使用、利用等目的，得將申請人及其連帶保證人之個人資料(包括財務資料等)與其他金融機關或徵信機關交換，或在上開特定之目的及範圍內，從事相關個人資料之搜集、電腦處理(包括委託第三者進行該等處理)、使用/利用，申請人並同意提供其資料予貴公司及其各關係企業，為進行共同行銷建檔、使用，但申請人及其連帶保證人得隨時要求停止對其相關資料交互運用，申請人及連帶保證人確認已受個人資料保護法第三條及第八條告知。
                  <br />3.甲方及其連帶保證人茲聲明本表正面及背面分期付款約定書條款，均經本人等於合理期間審閱無誤且充分了解同意，確認始簽章。
                  <br />4.甲方及其連帶保證人倘有違反分期付款約定書任一條款或延遲繳納分期款項時，申請人及其連帶保證人均授權
                  <b>和潤企業</b
                  >得不經通知逕行填載本票到期日，並得主張票據權利。
                </div>
              </td>
            </tr>
          </table>
          <!--ps-->
          <div class="leftSign">
            <span class="tdTit">申請人正楷簽名：</span>
            <img
              class="box"
              style="width: 125px; height: 30px"
              v-if="signImageSrc('signImage1')"
              :src="signImageSrc('signImage1')"
            />
          </div>
          <div class="rightSign">
            <span class="tdTit">連帶保證人正楷簽名：</span>
            <img
              class="box"
              style="width: 125px; height: 30px"
              v-if="signImageSrc('signImage2')"
              :src="signImageSrc('signImage2')"
            />
          </div>
          <div class="clear"></div>
          <div class="area5">
            <div class="loan_title">
              特&nbsp;&nbsp;&nbsp;&nbsp;約&nbsp;&nbsp;&nbsp;&nbsp;商&nbsp;&nbsp;&nbsp;&nbsp;填&nbsp;&nbsp;&nbsp;&nbsp;寫
            </div>
            <table class="table9">
              <tr class="trB">
                <td rowspan="2" class="title2" width="18px">
                  申
                  <br />辦 <br />產 <br />品
                </td>
                <td width="177px">
                  <span class="tdTit">廠牌：</span>
                  <div class="con61">{{ editedItem.laonhfcInfo.vendor }}</div>
                </td>
                <td width="195px">
                  <span class="tdTit">車名：</span>
                  <div class="con62">{{ editedItem.laonhfcInfo.name }}</div>
                </td>
                <td width="158px">
                  <span class="tdTit">出廠年月：</span>
                  <div class="con63">
                    <span class="y">
                      <span>年</span>
                      {{ editedItem.laonhfcInfo.publicYear }}
                    </span>
                    <span class="m">
                      <span>月</span>
                      {{ editedItem.laonhfcInfo.publicMonth }}
                    </span>
                  </div>
                </td>
                <td width="98px">
                  <span class="tdTit">車號：</span>
                  <div class="con64">{{ editedItem.laonhfcInfo.carId }}</div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit">CC：{{ editedItem.laonhfcInfo.cc }}</span>
                  <div class="con65"></div>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="tdTit">分期金額：</span>
                  <div class="con66">
                    {{
                      editedItem.vendor.totalPrice === 0
                        ? ""
                        : editedItem.vendor.totalPrice
                    }}
                  </div>
                  <!-- <div class="con66">{{editedItem.vendor.totalCreditPrice === 0 ? '' : editedItem.vendor.totalCreditPrice}}</div> -->
                </td>
                <td>
                  <span class="tdTit">分期期數：</span>
                  <div class="con67">
                    {{ editedItem.vendor.installmentsNumber }}
                  </div>
                </td>
                <td>
                  <span class="tdTit">期付款：</span>
                  <div class="con68">
                    {{
                      editedItem.vendor.creditPriceMonth === 0
                        ? ""
                        : editedItem.vendor.creditPriceMonth
                    }}
                  </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit">利率：</span>
                  <span class="con69">
                    <span>％</span>
                  </span>
                </td>
              </tr>
            </table>
            <table class="table10">
              <tr class="trB">
                <td width="198px">
                  <span class="tdTit">特約商名稱：</span>
                  <div class="con70">
                    <span></span>
                  </div>
                </td>
                <td width="195px">
                  <span class="tdTit">特約商統編：</span>
                  <div class="con71"></div>
                </td>
                <td rowspan="2" class="tdEnd stamp">
                  <span class="tdTit">公司章或發票章：</span>
                  <span class="stampPs"
                    >※債權轉讓確認章&nbsp;&nbsp;&nbsp;&nbsp;※延遲利息及違約金之請求權同意一併移轉受讓人</span
                  >
                </td>
              </tr>
              <tr>
                <td colspan="2" class="signBox">
                  <span class="tdTit">承辦人簽名：</span>
                  <img
                    class="box"
                    style="top: 15px; left: 10px; width: 125px; height: 30px"
                    v-if="signImageSrc('signImage3')"
                    :src="signImageSrc('signImage3')"
                  />
                  <span class="signBoxPs"
                    >※本人證實申請人及連帶保證人之身分正確並親自簽章無誤</span
                  >
                </td>
              </tr>
            </table>
          </div>
          <!--area4-->
          <div class="dash"></div>
          <div class="area6">
            <div class="loan_title">♦&nbsp;本&nbsp;&nbsp;&nbsp;&nbsp;票</div>
            <div class="con">
              <div class="conDiv">
                憑票於中華民國
                <span class="d1"></span>年 <span class="d1"></span>月
                <span class="d1"></span>日無條件支付
                <b>和潤企業股份有限公司</b>
                <br />
                <br />
                <b>
                  新台幣
                  <span class="money"></span>佰 <span class="money"></span>拾
                  <span class="money"></span>萬 <span class="money"></span>仟
                  <span class="money"></span>佰 <span class="money"></span>拾
                  <span class="money"></span>元整﹝必填﹞
                </b>
                <br />此本票免除作成拒絕證書及票據法第八十九條之通知義務，利息自到期日迄清償日止按年息百分之二十計付，發票人授權持票人得視實際情形自行填載發票日、本票金額、到期日。
                <br />付款地：
                <span class="place"></span>
                <br />
                <br />中華民國 <span class="d2"></span>年
                <span class="d2"></span>月
                <span class="d2"></span
                >日&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;發票人：
                <img
                  class="box"
                  style="width: 125px; height: 30px; top: 100px"
                  v-if="signImageSrc('signImage1')"
                  :src="signImageSrc('signImage1')"
                />
                <span v-else class="name"></span>發票人：
                <img
                  class="box"
                  style="width: 125px; height: 30px; top: 100px"
                  v-if="signImageSrc('signImage2')"
                  :src="signImageSrc('signImage2')"
                />
                <span class="name"></span>發票人：
                <span class="name"></span>
                <br />『
                此本票係供為分期付款買賣之分期款項總額憑證，俟分期付款完全清償完畢時，此本票自動失效，但如有一期未付，發票人願就本票債務負責清償。』
              </div>
              <!--conDiv-->
            </div>
            <div class="clear"></div>
            <span class="nb">FR-BA-050-001</span>
          </div>
          <!--area5-->
        </div>
        <!--page1-->
      </div>
    </div>
    <div style="margin:0 auto; display:flex; align-items:center; justify-content:center;">
      <v-btn color="primary" dark text @click="confirmEvent">下載PDF檔</v-btn>
    </div>
  </div>

  <!--wrapper-->
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { sortApplicationItem } from "@/pages/utils/tool";
import download from "downloadjs";
import * as htmlToImage from "html-to-image";
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from "html-to-image";

export default {
  name: "loanhfcView",
  props: {
    item: Object,
  },
  data() {
    return {
      checkedImage: require("../../assets/images/checked.png"),
      createDate: "",
      itemInfo: null,
    };
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
    editedItem() {
      this.itemInfo = sortApplicationItem(this.item);
      return this.itemInfo;
    },
  },
  methods: {
    ...mapActions(["fetchFinanceCreditInfo"]),
    signImageSrc(itemPath) {
      let source = "";
      if (itemPath === "signImage1") {
        if (this.editedItem.laonhfcInfo.signImage1) {
          source = this.editedItem.laonhfcInfo.signImage1;
        } else if (this.editedItem.laonhfcInfo.signimage1Url) {
          source = this.editedItem.laonhfcInfo.signimage1Url;
        }
      } else if (itemPath === "signImage2") {
        if (this.editedItem.laonhfcInfo.signImage2) {
          source = this.editedItem.laonhfcInfo.signImage2;
        } else if (this.editedItem.laonhfcInfo.signimage2Url) {
          source = this.editedItem.laonhfcInfo.signimage2Url;
        }
      } else if (itemPath === "signImage3") {
        if (this.editedItem.laonhfcInfo.signImage3) {
          source = this.editedItem.laonhfcInfo.signImage3;
        } else if (this.editedItem.laonhfcInfo.signimage3Url) {
          source = this.editedItem.laonhfcInfo.signimage3Url;
        }
      }
      return source;
    },
    confirmEvent() {
      const node = this.$refs.wrapper;      
      console.log(`node === ${node}`)
      this.$emit('ConvertPdfEvent', [node]);      
    },
  },
};
</script>

<style scoped src="../../assets/css/loanhfc_print.css">
.box {
  position: absolute;
  width: 125px;
  height: 35px;
}
</style>



// WEBPACK FOOTER //
// src/pages/web/loanhfcView.vue